import twoDigits from '../twoDigits';

// Set our days and months how we want them
const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Takes a Date object and returns a formatted string following the given format
export default function(date, format = 'dd/M/yyyy') {
	switch (format) {
		case 'dd/M/yyyy':
			return `${twoDigits(date.getDate())}/${months[date.getMonth()]}/${date.getFullYear()}`;
		case 'd/M/yyyy':
			return `${date.getDate()}/${months[date.getMonth()]}/${date.getFullYear()}`;
		case 'mm/dd/yyyy':
			return `${twoDigits(date.getMonth() + 1)}/${twoDigits(date.getDate())}/${date.getFullYear()}`;
		case 'm/d/yyyy':
			return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
		case 'D, dd M yyyy':
			return `${days[date.getDay()]}, ${twoDigits(date.getDate())} ${months[date.getMonth()]} ${date.getFullYear()}`;
		case 'M d, yyyy':
			return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
		default:
			return '';
	}
}
